export default __webpack_public_path__ + "static/media/location_mark.55a9ff03.svg";